import moment from 'moment'
import objectPath from 'object-path'

export const getDataLabelsValue = (value, options, properties) => {
  let serieIndex = options.seriesIndex
  let dataLabels = properties?.dataLabels
  let showSerieName = dataLabels?.showSerieName
  let showValue = dataLabels?.showValue
  let showPercent = dataLabels?.showPercent

  let nameLabel = ''
  let valueLabel = ''
  let percentLabel = ''
  let labelList = []
  if (showSerieName) {
    let prefixSerieName = dataLabels?.prefixSerieName || ''
    let suffixSerieName = dataLabels?.suffixSerieName || ''
    let value = options.w.globals.seriesNames[serieIndex]
    nameLabel = prefixSerieName + value + suffixSerieName
    if (nameLabel) {
      labelList.push(nameLabel)
    }
  }
  if (showValue) {
    let prefixValue = dataLabels?.prefixValue || ''
    let suffixValue = dataLabels?.suffixValue || ''
    let serie = options.w.globals.series[serieIndex]
    valueLabel = prefixValue + serie + suffixValue
    if (valueLabel) {
      labelList.push(valueLabel)
    }
  }
  if (showPercent) {
    let prefixPercent = dataLabels?.prefixPercent || ''
    let suffixPercent = dataLabels?.suffixPercent || ''
    let percent = options.w.globals.seriesPercent[serieIndex][0]
    percentLabel = prefixPercent + percent.toFixed(1) + '%' + suffixPercent
    if (percentLabel) {
      labelList.push(percentLabel)
    }
  }
  return labelList
}

export const getDataLabelDate = (value, options) => {
  let globals = options?.w?.globals
  let label = objectPath.get(globals, ['labels', options?.dataPointIndex])
  let a = moment(value[0])
  let b = moment(value[1])
  let diff = b.diff(a, 'days')
  label = label + ': ' + diff + (diff > 1 ? ' days' : ' day')
  return label
}

export const getDataLabels = (chartKey, properties) => {
  let dataLabelsValue = ['donut', 'pie']
  let dataLabelsDate = ['timeline']
  if (dataLabelsValue.includes(chartKey)) {
    return {
      formatterKey: `dataLabels.formatter`,
      formatter: (value, options) =>
        getDataLabelsValue(value, options, properties),
    }
  }
  if (dataLabelsDate.includes(chartKey)) {
    return {
      formatterKey: `dataLabels.formatter`,
      formatter: (value, options) => getDataLabelDate(value, options),
    }
  }
  return null
}
